import Api from './Api';

const END_POINT = "employees";

export default {
  async get_all(filters = null) {
    let request = {
      params: filters,
    };
    return await Api.get(`${END_POINT}`, request);
  },
  async store(employee) {
    return await Api.post(`${END_POINT}`, employee);
  },
  async update(employee) {
    return await Api.patch(`${END_POINT}/${employee.id}`, employee);
  },
  async change_status(employee) {
    return await Api.patch(
      `${END_POINT}/${employee.id}/change-status`,
      employee
    );
  },
  async delete(employee) {
    return await Api.delete(`${END_POINT}/${employee.id}`, employee);
  },
  async get_worker(filters = null) {
    let request = {
      params: filters,
    };
    return await Api.get(`${END_POINT}/get-workers`, request);
  },
  async bajaEmpleado(employee) {
    await Api.post("baja-empleado", employee);
  },
  async employeeDownload() {
    return await Api.get("empleado/download");
  },
};
